var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingPageCtaBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1920 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1601.3 222.035C1606.29 222.035 1606.29 214.283 1601.3 214.283C1596.32 214.283 1596.32 222.035 1601.3 222.035Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.88 160.876C1501.39 160.876 1501.39 157 1498.88 157C1496.37 157 1496.37 160.876 1498.88 160.876Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.57 257.509C1555.08 257.509 1555.08 253.633 1552.57 253.633C1550.06 253.633 1550.06 257.509 1552.57 257.509Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M568.74 209.751C573.727 209.751 573.727 202 568.74 202C563.753 202 563.753 209.751 568.74 209.751Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.68 89.7515C447.666 89.7515 447.666 82 442.68 82C437.693 82 437.693 89.7515 442.68 89.7515Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.88 151.405C387.386 151.405 387.386 147.529 384.88 147.529C382.373 147.529 382.373 151.405 384.88 151.405Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M457.356 256.1C459.863 256.1 459.863 252.225 457.356 252.225C454.85 252.225 454.85 256.1 457.356 256.1Z",
    fill: "#A3EA2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPageCtaBackground);
export default __webpack_public_path__ + "static/media/pricing-page-cta-background.569fbb7260de7e0a5c5cd20189d2cea3.svg";
export { ForwardRef as ReactComponent };